import { ProgressStepsProps, StatusIconProps } from "./types";
import styles from "./styles.scss";
import React from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import { serviceCaller } from "../../../../composition";
import withStyles from "isomorphic-style-loader/withStyles";

const StatusIcon = ({ isActive }: StatusIconProps) => {
  return (
    <div
      style={{
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <i
        className={`fa fa-check ${styles.stepIcon} ${
          isActive ? styles.completedColor : styles.pendingColor
        }`}
      />
    </div>
  );
};

const ProgressSteps = ({ stepsList, currentStep }: ProgressStepsProps) => {
  return (
    <div className={styles.progressContainer}>
      <ListGroup className={styles.stepsList}>
        {stepsList.map((step, index) => (
          <ListGroupItem key={index} className={styles.stepItem}>
            <StatusIcon isActive={currentStep > index} />
            <span
              className={`${
                currentStep > index
                  ? styles.completedColor
                  : styles.pendingColor
              }`}
            >
              {step.label}
            </span>
            {index < stepsList.length - 1 && (
              <span
                className={`${styles.divider} ${
                  currentStep - 1 > index
                    ? styles.completedColor
                    : styles.pendingColor
                }`}
              >
                ————
              </span>
            )}
          </ListGroupItem>
        ))}
      </ListGroup>
    </div>
  );
};

export default serviceCaller(withStyles(styles)(ProgressSteps));
